import { render, staticRenderFns } from "./EditSegment.vue?vue&type=template&id=3a84521a&scoped=true"
import script from "./EditSegment.vue?vue&type=script&lang=js"
export * from "./EditSegment.vue?vue&type=script&lang=js"
import style0 from "./EditSegment.vue?vue&type=style&index=0&id=3a84521a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a84521a",
  null
  
)

export default component.exports